import { AnimatePresence } from 'framer-motion'
import { useAuthStore } from '@/store/auth'
import { useHeaderStore } from '@/store/headerStore'
import { useHeaderScroll } from '@/hooks/useHeaderScroll'
import { HeaderContent } from './HeaderContent'
import { HeaderLogo } from './HeaderLogo'
import { HeaderAvatar } from './HeaderAvatar'
import { HeaderActions } from './HeaderActions'
import { HeaderContextBar } from './HeaderContextBar'

interface AppHeaderProps {
  onMenuClick: () => void
}

export function AppHeader({ onMenuClick }: AppHeaderProps) {
  const { user } = useAuthStore()
  const { isScrolled, isCollapsed, scrollDirection } = useHeaderScroll()
  const { contextActions, pageTitle } = useHeaderStore()

  const showCollapsed = isCollapsed && scrollDirection === 'down'

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <HeaderContent isScrolled={isScrolled} isCollapsed={showCollapsed}>
        <div className="flex items-center justify-between h-full px-4 max-w-157.5 mx-auto">
          {/* Left side: Avatar + Logo */}
          <div className="flex items-center gap-3">
            <HeaderAvatar user={user} />
            <HeaderLogo collapsed={showCollapsed} title={pageTitle} />
          </div>

          {/* Right side: Actions */}
          <HeaderActions onMenuClick={onMenuClick} />
        </div>
      </HeaderContent>

      {/* Contextual actions bar */}
      <AnimatePresence>
        {contextActions.length > 0 && (
          <HeaderContextBar actions={contextActions} />
        )}
      </AnimatePresence>
    </header>
  )
}
